/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.contentEditorModule')
.controller('VideoBlockController', ['$scope', 'CONFIG', 'CONTENT_EDITOR', VideoBlockController]);

/**
 *
 */
function VideoBlockController($scope, CONFIG, CONTENT_EDITOR) {
  var that = this;

  this.width = 815;
  this.height = $scope.contentBlockCtrl.contentBlock.video.jspType === 'TRANSCODING' ? 600 : 458;
  this.isPlaying = false;

  this.updateVideoSize = function() {
    // update the width:
    var contentSize = jQuery('.bulb-page-content').width();
    var maxSize = CONFIG.page.content.max.width;
    var scale = contentSize/maxSize;
    that.width = $scope.contentBlockCtrl.contentBlock.width * scale;

    // update the height:
    switch ($scope.contentBlockCtrl.contentBlock.video.jspType) {
      case 'ASSET':
        var width = $scope.contentBlockCtrl.contentBlock.video.transcodedAssets[0].width;
        var height = $scope.contentBlockCtrl.contentBlock.video.transcodedAssets[0].height;
        var aspectRatio = width / height;
        that.height = that.width / aspectRatio;
        break;
      case 'VIMEO':
        if (that.vimeoPlayer) {
          that.vimeoPlayer.getVideoWidth().then( function(width) {
            that.vimeoPlayer.getVideoHeight().then( function() {
              var aspectRatio = width / height;
              that.height = that.width / aspectRatio;
              $scope.$apply();
            }).catch(function() {
              // do nothing?
            });
          }).catch(function() {
            // do nothing?
          });
        } else {
          // Vimeo video isn't loaded yet, so untit it does, assume we are standard 16:9
          that.height = that.width / CONFIG.embed.default.aspect.ratio;
        }
        break;
    }

    // Determines if the width of the video block is larger than what we allow for content to the go to the right or
    // left on a right/left align.
    $scope.contentBlockCtrl.isFullWidth = ($scope.contentBlockCtrl.contentBlock.width >
      (maxSize * CONTENT_EDITOR.FULL_BLOCK_WIDTH_PERCENTAGE));
  };

  this.play = function() {
    if ($scope.contentBlockCtrl.contentBlock.video.jspType === 'VIMEO') {
      if (that.vimeoPlayer) {
        that.vimeoPlayer.getPaused().then( function(isPaused) {
          if (isPaused) {
            that.vimeoPlayer.play().catch(function (error) {
              console.error('error playing the video:', error.name);
            });
          } else {
            that.vimeoPlayer.pause().catch(function(error) {
              console.error('error playing the video:', error.name);
            });
          }
        });
      }
    } else {
      $scope.$broadcast('bulb-video-play-toggle', 'content-block-' + $scope.contentBlockCtrl.contentBlock.id);
      // So we don't show the blue play button on top of a playing video.
      // Configured as a toggle in case we want to expand on this later.
      that.isPlaying = !that.isPlaying;
    }
  };

  $scope.$watchCollection('contentBlockCtrl.contentBlock', function() {
    that.updateVideoSize();
  });
}

